<div class="justup-dialog-large of-list-dialog">
  <vl-dialog-header-export
    [exporting]="exporting()"
    (close)="dialogRef.close()"
    (export)="exportExcel()">
    OFs en attente
  </vl-dialog-header-export>

  <div class="justup-dialog-content flex-col gap-16">

    <!-- Stats cards -->
    <div class="flex-row gap-8 wrap">
      <vl-radio-card mode="display" color="warn" icon="hourglass_empty"
                     title="OFs en attente"
                     style="flex: 1; min-width: 160px">
        <span content class="headline">{{ stats().total }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="error" icon="schedule"
                     title="Plus ancien"
                     style="flex: 1; min-width: 160px"
                     matTooltip="Nombre de jours depuis la date prévue de début du plus ancien OF en attente">
        <span content class="headline">
          @if (stats().oldest != null) {
            {{ stats().oldest }} j
          } @else {
            —
          }
        </span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="secondary" icon="timer"
                     title="Attente moyenne"
                     style="flex: 1; min-width: 160px">
        <span content class="headline">
          @if (stats().avg != null) {
            {{ stats().avg | number:'1.0-0' }} j
          } @else {
            —
          }
        </span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="basic" icon="bar_chart"
                     title="État dominant"
                     style="flex: 1; min-width: 160px">
        <div content class="flex-col gap-2">
          <span class="body-1" style="font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
            {{ stats().topEtatLabel }}
          </span>
          <span class="tiny" style="opacity: 0.7">
            {{ stats().topEtatCount }} OF{{ stats().topEtatCount > 1 ? 's' : '' }}
          </span>
        </div>
      </vl-radio-card>
    </div>

    <!-- Filtres -->
    <div class="flex-row gap-8 wrap align-center">
      <div class="flex-row gap-4 wrap">
        @for (opt of subTypeOptions(); track opt.value) {
          <vl-chips
            [bubble]="opt.count"
            [contentHeight]="true"
            size="small"
            [state]="subType() === opt.value ? 'active' : 'enabled'"
            (action)="subType.set(opt.value)">
            {{ opt.name }}
          </vl-chips>
        }
      </div>
      <div class="grow"></div>
      <vl-input-search
        [(value)]="search"
        placeholder="Numéro, ligne, article…"
        style="min-width: 220px"
      />
    </div>

    <!-- Table -->
    <div class="of-table-wrapper">
      <table class="of-table">
        <thead>
          <tr>
            <th class="sortable" (click)="toggleSort('numero')">
              Numéro
              @if (sortKey() === 'numero') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable" (click)="toggleSort('ligne')">
              Ligne
              @if (sortKey() === 'ligne') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable" (click)="toggleSort('article')">
              Article
              @if (sortKey() === 'article') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable num" (click)="toggleSort('quantite')">
              Quantité
              @if (sortKey() === 'quantite') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable" (click)="toggleSort('etat')">
              État
              @if (sortKey() === 'etat') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable" (click)="toggleSort('dateDebut')"
                matTooltip="Date prévue quand renseignée, sinon date de création de l'OF">
              Date
              @if (sortKey() === 'dateDebut') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable num" (click)="toggleSort('attente')"
                matTooltip="Jours écoulés depuis la date de référence">
              Attente
              @if (sortKey() === 'attente') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (of of filteredOfs(); track of.id) {
            <tr class="row" (click)="onSelectOf(of)" tabindex="0"
                (keydown.enter)="onSelectOf(of)">
              <td class="numero">{{ of.numero }}</td>
              <td>{{ of.ligne?.denomination ?? '—' }}</td>
              <td class="article">
                <div class="article-cell">
                  <span class="article-name">{{ of.articleInfos?.denomination ?? '—' }}</span>
                  @if (of.articleInfos?.code) {
                    <span class="article-code on-disabled tiny">{{ of.articleInfos.code }}</span>
                  }
                </div>
              </td>
              <td class="num">{{ of.quantite | number:'1.0-2' }}</td>
              <td><vl-etat-of [etat]="of.etat"/></td>
              <td>
                @if (refDate(of)) {
                  <span [matTooltip]="isPlannedDate(of) ? 'Date prévue de début' : 'Date de création (pas de date planifiée)'">
                    {{ refDate(of) | date:'dd/MM/yyyy' }}
                    @if (!isPlannedDate(of)) {
                      <mat-icon class="hint-icon">add_circle_outline</mat-icon>
                    }
                  </span>
                } @else {
                  —
                }
              </td>
              <td class="num">
                @if (attenteJours(of) != null) {
                  {{ attenteJours(of) }} j
                } @else {
                  —
                }
              </td>
              <td class="action">
                <mat-icon class="on-accent">arrow_forward</mat-icon>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="8" class="empty">
                {{ 'list.empty' | trans }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
